module.exports = __webpack_public_path__ + "media/images/front/icon_db-keisai-ad983b30f201871b41a7d4eb828726ae.png";